import { LoaderCircleV2 } from 'oolib'
import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { __CheckAccessToModule, __CheckSomeAccessToSomePlatformBuilderModule } from '../../../utils/accessControl'
import { useGetQueryState } from '../../../utils/react-query-hooks/general'

const RouteSomeAccessSomePlatformBuilderModule = ({ children, ACTIONS, modules }) => {
  const location = useLocation()
  const { status, data: userData } = useGetQueryState('userData')

  const hasAccess = () => {
    const checkAccess = (user) => {
      return __CheckSomeAccessToSomePlatformBuilderModule({
        user,
        actions: ACTIONS,
        modules,
      }) || __CheckAccessToModule(user, 'READ', 'usersManager')
    }

    if (!userData?.user) {
      // not logged in
      return {
        has: checkAccess(undefined),
        redirectTo: {
          pathname: '/login',
          state: {
            from: location.pathname + location.search,
          },
        },
      }
    }

    // else is logged in, and either has access to this content type or not.
    // if has, then let them through.
    // if not then simply redir back to the page they were coming from.
    return {
      has: checkAccess(userData?.user),
      redirectTo: '/',
    }
  }

  if (status === 'loading') {
    return <LoaderCircleV2 />
  }

  if (!hasAccess().has) {
    return <Navigate to={hasAccess().redirectTo} replace />
  }

  return children
}

export default RouteSomeAccessSomePlatformBuilderModule
